<template>
  <div style="margin: 10px; height: 700px">
    <v-form
      direction="horizontal"
      :model="options"
      :rules="rules"
      ref="ruleForm"
    >
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button type="success" icon="save" @click.prevent="save('ruleForm')"
            >保存</v-button
          >
        </v-affix>
      </div>

      <v-form-item
        label="姓名"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        prop="xm"
        has-feedback
        required
      >
        <v-input v-model="options.xm" placeholder="姓名"></v-input>
      </v-form-item>

      <v-form-item
        label="职位"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.zw" placeholder="职位"></v-input>
      </v-form-item>

      <v-form-item
        label="联系电话"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        prop="lxdh"
      >
        <v-input v-model="options.lxdh" placeholder="联系电话"></v-input>
      </v-form-item>

      <v-form-item
        label="部门"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        prop="bmid"
        has-feedback
        required
      >
        <v-select
          style="width: 100%"
          :data="bm_options"
          v-model="options.bmid"
        ></v-select>
      </v-form-item>

      <v-form-item
        label="性别"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-select
          style="width: 100%"
          :data="xb_options"
          v-model="options.xb"
        ></v-select>
      </v-form-item>

      <v-form-item
        label="登入用户名"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        v-show="showGroup"
        prop="yhm"
        has-feedback
        required
      >
        <v-input v-model="options.yhm" placeholder="登入用户名"></v-input>
      </v-form-item>

      <v-form-item
        label="登入密码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        v-show="showGroup"
        prop="mm"
        has-feedback
        required
      >
        <v-input
          type="password"
          v-model="options.mm"
          placeholder="登入密码"
          v-show="showGroup"
        ></v-input>
      </v-form-item>

      <v-form-item
        label="确认密码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        v-show="showGroup"
        prop="qrmm"
        has-feedback
        required
      >
        <v-input
          type="password"
          v-model="options.qrmm"
          placeholder="确认密码"
          v-show="showGroup"
        ></v-input>
      </v-form-item>

      <v-form-item
        label="启用"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-switch v-model="options.xybz"></v-switch>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
let options = {
  gh: "",
  xm: "",
  zw: "",
  lxdh: "",
  xb: "",
  yhm: "",
  mm: "",
  qrmm: "",
  xybz: true,
  bmid: ""
};

var validateLxdh = (rule, value, callback) => {
  if (value == "") {
    callback()
  }
  if (value.substring(0, 1) != '1' || value.length < 11 || value.length > 11) {

    callback(new Error('请输入正确的手机号码格式'));
  }
  else {
    callback()
  }
}

var validateMm = (rule, value, callback) => {
  var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  if (!reg.test(value)) {
    callback(new Error('密码格式必须大于8位并且由数字、字母及特殊字符组成'));
  }
  else {
    callback()
  }
}

var validateQrmm = (rule, value, callback) => {
  if (value != options.mm) {
    callback(new Error('两次密码需一致'));
  }
  else {
    callback()
  }
}
export default {
  data() {
    return {
      validateLxdh,
      validateMm,
      validateQrmm,
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      xb_options: [
        {
          value: "1",
          label: "男",
        },
        {
          value: "2",
          label: "女",
        },
      ],
      options,
      bm_options: [],
      rules: {
        xm: [{
          required: true,
          message: '请输入姓名'
        }],
        yhm: [{
          required: true,
          message: '请输入用户名'
        }],
        mm: [{
          required: true,
          message: '请输入密码'
        }, {
          validator: validateMm
        }],
        qrmm: [{
          required: true,
          message: '请输入确认密码'
        }
          , {
          validator: validateQrmm
        }],
        bmid: [{
          required: true,
          message: '请选择部门'
        }],
        lxdh: [{
          validator: validateLxdh
        }]
      },
      showGroup: true,
    };
  },
  created() {
    this.init_bm();
    if (this.$route.query.gh) {
      this.init();
      this.showGroup = false;
      this.rules = {
          xm: [{
            required: true,
            message: '请输入姓名'
          }],
          yhm: [{
            required: true,
            message: '请输入用户名'
          }],
          bmid: [{
            required: true,
            message: '请选择部门'
          }],
          lxdh: [{
            validator: validateLxdh
          }],
        };
    }
  },
  methods: {
    init() {
      this.$axios
        .get("api/system/qxgl/get-rywh-first?gh=" + this.$route.query.gh)
        .then((res) => {
          this.options = res.data.data[0];
          if (res.data.data[0].xybz == 1) {
            this.options.xybz = true;
          } else {
            this.options.xybz = false;
          }
        });
    },
    init_bm() {
      this.$axios.get("api/system/qxgl/get-sysbm-list").then((res) => {
        this.bm_options = res.data.map((item) => {
          return { value: item.id, label: item.bmmc };
        });
      });
    },
    save(formName) {
      if (this.$route.query.gh) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios
              .post("api/system/qxgl/update-rywh-first", this.options)
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message["success"](res.data.message);
                  xadmin.close();
                  // xadmin.father_reload();
                } else {
                  this.$message["error"](res.data.message);
                }
              });
          }
        })
      } else {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.$axios
                .get("api/system/qxgl/get-rywh-yhm?yhm=" + this.options.yhm)
                .then((res) => {
                  if (res.data.message == 1) {
                    this.$axios
                      .post("api/system/qxgl/set-rywh-first", this.options)
                      .then((res) => {
                        if (res.data.code == 200) {
                          this.$message["success"](res.data.message);
                          xadmin.close();
                          // xadmin.father_reload();
                        } else {
                          this.$message["error"](res.data.message);
                        }
                      });
                  } else {
                    this.$message["error"]("用户名已存在请重新输入！");
                    return;
                  }
                });
            }
          });
      }
    }
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/yhgl/rywhadd.vue